// create a new Bank
import GlLevel2Service from "../../services/oldServices/GlLevel2Service";

const getDefaultState = () => {
  return {
    test: "",
    moduleLoading: false,
    // moduleLoadingTwo: true,
    moduleLoadingThree: true,
    moduleLoadingFour: false,
    moduleLoadingFive: true,
    moduleLoadingSix: false,
    createGlLevel2FormBody: {
      // source: "web"
    },
    // bankStatData: {},
    glLevel2data: [],
    allGlLevel2CheckersQueue: [],
    glLevel2BankData: []
  };
};
export const state = getDefaultState();

export const getters = {
  // Checks if bank stats have already been fetched
  isGlLevel2SpecificToAllBanks: state => {
    return state.glLevel2BankData.map(data => {
      return data.glLevel2Description;
    });
  },

  isModuleLoadingFour: state => {
    return state.moduleLoadingFour;
  }
};

export const mutations = {
  // RESET State
  RESET_STATE(state) {
    Object.assign(state, getDefaultState());
  },
  SET_TEST(state, payload) {
    state.test = payload;
  },
  SET_LOADING(state, status) {
    state.moduleLoading = status;
  },

  SET_LOADING_THREE(state, status) {
    state.moduleLoadingThree = status;
  },
  SET_LOADING_FOUR(state, status) {
    state.moduleLoadingFour = status;
  },
  SET_LOADING_FIVE(state, status) {
    state.moduleLoadingFive = status;
  },
  SET_LOADING_SIX(state, status) {
    state.moduleLoadingSix = status;
  },

  SET_ALL_GL_LEVEL_2(state, payload) {
    state.glLevel2data = payload;
  },
  SET_GL_LEVEL_2_CHECKERS_QUEUE(state, payload) {
    state.allGlLevel2CheckersQueue = payload;
  },

  SET_ALL_GL_LEVEL_2_BANKS(state, payload) {
    state.glLevel2BankData = payload;
  }
};
export const actions = {
  checkerAuthorizeGlLevel2({ commit, dispatch }, payload) {
    // start loader
    commit("SET_LOADING_SIX", true);

    return GlLevel2Service.checkerAuthorizeGlLevel2(payload)
      .then(response => {
        // stop loader
        commit("SET_LOADING_SIX", false);

        let responseData = response.data;

        if (responseData.responseCode === "00") {
          // push Notification
          const notification = {
            type: "success",
            message: `Success - ${responseData.responseMessage}`
          };
          dispatch("notification/add", notification, { root: true });
        } else {
          // push Notification
          const notification = {
            type: "error",
            message: `Error - ${responseData.responseMessage}`
          };
          dispatch("notification/add", notification, { root: true });
        }
        return responseData;
      })
      .catch(error => {
        //stop loader
        commit("SET_LOADING_SIX", false);

        throw error;
      });
  },

  allGlLevel2CheckersQueue({ commit, dispatch }, payload) {
    // start loader
    commit("SET_LOADING_FIVE", true);

    return GlLevel2Service.allGlLevel2CheckersQueue(payload)
      .then(response => {
        // stop loader
        commit("SET_LOADING_FIVE", false);

        let responseData = response.data;

        if (responseData.responseCode === "00") {
          commit("SET_GL_LEVEL_2_CHECKERS_QUEUE", responseData.data);
        } else {
          // push Notification
          const notification = {
            type: "error",
            message: `Error - Error Loading Table | Try again`
          };
          dispatch("notification/add", notification, { root: true });
        }
      })
      .catch(error => {
        //stop loader
        commit("SET_LOADING_FIVE", false);

        throw error;
      });
  },

  createGlLevel2({ commit, dispatch }, payload) {
    // start loader
    commit("SET_LOADING", true);

    return GlLevel2Service.createGlLevel2(payload)
      .then(response => {
        // stop loader
        commit("SET_LOADING", false);

        let responseData = response.data;

        if (responseData.responseCode === "00") {
          // push Notification
          const notification = {
            type: "success",
            variant: "success",
            message: `${responseData.responseMessage}`
          };
          dispatch("notification/add", notification, { root: true });
        } else {
          // push Notification
          const notification = {
            type: "error",
            variant: "danger",
            message: `Error - ${responseData.responseMessage}`
          };
          dispatch("notification/add", notification, { root: true });
        }
      })
      .catch(error => {
        //stop loader
        commit("SET_LOADING", false);

        throw error;
      });
  },
  // list all gl level2 pertaining to all banks
  allGlLevel2({ commit, dispatch }, payload) {
    commit("SET_TEST", "test");

    // start loader
    commit("SET_LOADING_THREE", true);

    return GlLevel2Service.allGlLevel2(payload)
      .then(response => {
        // stop loader
        commit("SET_LOADING_THREE", false);

        let responseData = response.data;

        if (responseData.responseCode === "00") {
          commit("SET_ALL_GL_LEVEL_2", responseData.data);
        } else {
          // push Notification
          const notification = {
            type: "error",
            variant: "danger",
            message: `Error - Error Loading Table | Try again`
          };
          dispatch("notification/add", notification, { root: true });
        }
      })
      .catch(error => {
        //stop loader
        commit("SET_LOADING_THREE", false);

        throw error;
      });
  },

  //read GL Level 2 specific to bank which means readALL in body request will be NO
  allGlLevel2SpecificToBanks({ commit, dispatch }, payload) {
    commit("SET_TEST", "test");

    return GlLevel2Service.allGlLevel2SpecificToBanks(payload)
      .then(response => {
        // stop loader
        commit("SET_LOADING_FOUR", false);

        let responseData = response.data;

        if (responseData.responseCode === "00") {
          commit("SET_ALL_GL_LEVEL_2_BANKS", responseData.data);
        } else {
          // push Notification
          const notification = {
            type: "error",
            variant: "danger",
            message: `Error - Error Loading Table | Try again`
          };
          dispatch("notification/add", notification, { root: true });
        }
      })
      .catch(error => {
        //stop loader
        commit("SET_LOADING_FOUR", false);

        throw error;
      });
  },

  // Reset State
  resetState({ commit }) {
    commit("RESET_STATE");
  }
};
